/* Sleep LP Research — before/after compare slider
   Apple-style draggable divider revealing the "after" image. */
(function () {
  'use strict';

  function initCompare(root) {
    var frame = root.querySelector('.sleep-research__compare-frame');
    var after = root.querySelector('[data-research-after]');
    var handle = root.querySelector('[data-research-handle]');
    if (!frame || !after || !handle) return;

    function setPercent(pct) {
      pct = Math.max(0, Math.min(100, pct));
      root.style.setProperty('--start', pct + '%');
    }

    function fromEvent(e) {
      var rect = frame.getBoundingClientRect();
      var pct = ((e.clientX - rect.left) / rect.width) * 100;
      setPercent(pct);
    }

    var dragging = false;
    function onDown(e) {
      dragging = true;
      handle.setPointerCapture && handle.setPointerCapture(e.pointerId);
      fromEvent(e);
    }
    function onMove(e) { if (dragging) fromEvent(e); }
    function onUp() { dragging = false; }

    handle.addEventListener('pointerdown', onDown);
    handle.addEventListener('pointermove', onMove);
    handle.addEventListener('pointerup', onUp);
    handle.addEventListener('pointercancel', onUp);
    frame.addEventListener('pointerdown', function (e) {
      if (e.target === handle || handle.contains(e.target)) return;
      fromEvent(e);
    });

    handle.addEventListener('keydown', function (e) {
      var current = parseFloat(getComputedStyle(root).getPropertyValue('--start')) || 50;
      if (e.key === 'ArrowLeft') { setPercent(current - 5); e.preventDefault(); }
      else if (e.key === 'ArrowRight') { setPercent(current + 5); e.preventDefault(); }
    });
  }

  function initShootingStars(root) {
    if (root.__sleepResearchSky) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var sky = document.createElement('div');
    sky.className = 'sleep-research__sky';
    root.insertBefore(sky, root.firstChild);
    root.__sleepResearchSky = sky;

    var COUNT = 8;
    for (var i = 0; i < COUNT; i++) {
      var s = document.createElement('span');
      s.className = 'sleep-research__shooting-star';
      sky.appendChild(s);
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          sky.classList.toggle('is-active', e.isIntersecting);
        });
      }, { rootMargin: '100px 0px' });
      io.observe(root);
    } else {
      sky.classList.add('is-active');
    }
  }

  function initCardsDrag(root) {
    var track = root.querySelector('[data-research-cards-track]');
    if (!track) return;

    var dragging = false;
    var startX = 0;
    var startScroll = 0;
    var pointerDownTime = 0;
    var moved = false;

    function onDown(e) {
      // Only left mouse / touch / pen
      if (e.button !== undefined && e.button !== 0) return;
      dragging = true;
      moved = false;
      startX = e.clientX;
      startScroll = track.scrollLeft;
      pointerDownTime = Date.now();
      track.classList.add('is-dragging');
      try { track.setPointerCapture(e.pointerId); } catch (err) {}
    }

    function onMove(e) {
      if (!dragging) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 3) moved = true;
      track.scrollLeft = startScroll - dx;
    }

    function onUp(e) {
      if (!dragging) return;
      dragging = false;
      track.classList.remove('is-dragging');
      try { track.releasePointerCapture(e.pointerId); } catch (err) {}
    }

    // Prevent click events when the drag actually moved the carousel
    function onClickCapture(e) {
      if (moved) {
        e.preventDefault();
        e.stopPropagation();
        moved = false;
      }
    }

    track.addEventListener('pointerdown', onDown);
    track.addEventListener('pointermove', onMove);
    track.addEventListener('pointerup', onUp);
    track.addEventListener('pointercancel', onUp);
    track.addEventListener('pointerleave', onUp);
    track.addEventListener('click', onClickCapture, true);
  }

  function init() {
    document.querySelectorAll('[data-research-compare]').forEach(initCompare);
    document.querySelectorAll('[data-research-stars]').forEach(initShootingStars);
    document.querySelectorAll('[data-research-cards]').forEach(initCardsDrag);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) {
    if (!e.target.querySelectorAll) return;
    e.target.querySelectorAll('[data-research-compare]').forEach(initCompare);
    e.target.querySelectorAll('[data-research-stars]').forEach(initShootingStars);
    e.target.querySelectorAll('[data-research-cards]').forEach(initCardsDrag);
  });
})();
